import { render, staticRenderFns } from "./number_of_approvals.vue?vue&type=template&id=03693213"
import script from "./number_of_approvals.vue?vue&type=script&lang=js"
export * from "./number_of_approvals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports